import React from "react"
import {
  TableBody,
  TableContainer,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableRowCell,
} from "containers/Table"
import HeaderTabContainer from "containers/HeaderTabContainer"
import HeaderTab from "components/HeaderTab"
import { ArchiveRequest } from "./index"

const MockTable = () => (
  <TableContainer>
    <TableHeader loading>
      <TableHeaderCell>User Name</TableHeaderCell>
      <TableHeaderCell>Email</TableHeaderCell>
      <TableHeaderCell>Children</TableHeaderCell>
      <TableHeaderCell>Archived?</TableHeaderCell>
    </TableHeader>
    <TableBody>
      {[1, 2, 3].map((row, i) => (
        <TableRow key={i} loading>
          <TableRowCell>Data</TableRowCell>
          <TableRowCell>Data</TableRowCell>
          <TableRowCell>Data</TableRowCell>
          <TableRowCell>
            <ArchiveRequest>Cancel Request</ArchiveRequest>
          </TableRowCell>
        </TableRow>
      ))}
    </TableBody>
  </TableContainer>
)
const CampInfoRequestsLoading = () => (
  <HeaderTabContainer default="/info_requests" mountPath="/info_requests">
    <HeaderTab key={0} title="Active" path={`/info_requests/active`}>
      <MockTable />
    </HeaderTab>
    <HeaderTab key={1} title="Archived" path={`/info_requests/archived`}>
      <MockTable />
    </HeaderTab>
  </HeaderTabContainer>
)

export default CampInfoRequestsLoading



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampInfoRequests/CampInfoRequests.loading.js